import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("我的")

import { reactive, ref, onMounted, computed } from 'vue';
import { PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Tabbar',
  setup(__props) {

const Options = ref({
  name: '标签栏'
})

const tabbarOptions = ref({
  active: 0,
  change: (page: string) => {

    console.log(page)

  }
})

onMounted(() => {


})


return (_ctx: any,_cache: any) => {
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item")!
  const _component_van_tabbar = _resolveComponent("van-tabbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_tabbar, {
      modelValue: tabbarOptions.value.active,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tabbarOptions.value.active) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tabbar_item, {
          icon: "home-o",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (tabbarOptions.value.change('index')))
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_van_tabbar_item, {
          icon: "setting-o",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (tabbarOptions.value.change('profile')))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})